import React, { Component } from 'react';
import PropTypes from 'prop-types';
import s from './MentionList.css';
import UserDropdown from '../UserDropdown/UserDropdownContainer';


export default class MentionList extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    textCursorPos: PropTypes.number.isRequired,
    textChangeCallback: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = this.buildCurrentState(props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text || prevProps.textCursorPos !== this.props.textCursorPos) {
      this.setState(this.buildCurrentState(this.props));
    }
  };

  buildCurrentState = props => {
    const { text, textCursorPos } = props;
    const activeTextStart = this.getActiveTextStartingPos(text, textCursorPos);
    const activeText = text.substring(activeTextStart, textCursorPos);

    return {
      activeTextStart,
      activeText,
      show: text[activeTextStart] === '@'
    };
  };

  hideMentionList = () => this.setState({ show: false });

  /**
   * Updates the text property by invoking the text change callback with the whole text string
   * and the currently selected mention name at the current word.
   */
  updateTextWithMentionName = userId => {
    const updatedText = this.replaceActiveTextWithMention(userId);
    this.props.textChangeCallback(updatedText);
  };

  /**
   * Inserts the selected user into the full text string.
   * @returns The complete text string with the selected mention name inserted.
   */
  replaceActiveTextWithMention = userId => {
    const { text, textCursorPos, users } = this.props;
    const { activeTextStart } = this.state;

    const selectedUser = users[userId];
    const userMentionNameStr = `@${selectedUser.mentionName} `; // The space at the end is intended.

    return activeTextStart === 0
      ? userMentionNameStr + text.substring(textCursorPos)
      : text.substring(0, activeTextStart) + userMentionNameStr + text.substring(textCursorPos);
  };

  /**
   * The active text is defined as the substring from the start of the current word to the current position of the cursor.
   * @param text The entire text string
   * @param textCursorPos the index of the cursor in the text string
   * @returns the index of the beginning of the active text
   */
  getActiveTextStartingPos = (text, textCursorPos) => {
    let searchPos = textCursorPos;
    do {
      searchPos--
    } while (!text.charAt(searchPos).match(/\s/) && searchPos > -1);

    return searchPos + 1;
  };

  render = () => {
    const { activeText, show } = this.state;

    return (
        <UserDropdown
          qaId="mentionList"
          className={s.mentionListContainer}
          onSelect={this.updateTextWithMentionName}
          onHide={this.hideMentionList}
          text={activeText.substring(1)}
          show={show}
        />
    )
  }
}
